import React, { useEffect } from 'react';
import { useSortBy, useTable } from "react-table";
import { useColumns } from "../../../shared/components/Table/utils";
import Table from "../../../shared/components/Table";
import { NoResults } from "../../../shared/svg/Svg";
import { getEmptyStatTableValuesAccessors } from "../../../shared/utils";
import { useReactAppState } from "../../../shared/containers/utils";
import { round } from "../../../../libraries/_helpers";
import { averageValues } from '../../utils';

const PlayersCareerTable = ({ baseClass, emptyResultsComponent, playerData, statType, order, setOrder }) => {
  const { t } = useReactAppState();
  const columns = useColumns(statType, playerData);
  const columnAccessors = columns[0].columns.map((el) => el?.accessor);
  const getTotal = (columnAccessors, playerData) => {
    if (columnAccessors?.length && playerData?.length) {
      const total = {};
      const totalRecordsCount = {};

      columnAccessors.forEach((accessor) => {
        Object.defineProperty(total, accessor, {
          value: accessor === "date" ? t("total") : (accessor === "name" ? "" : 0),
          writable: true,
          enumerable: true
        });
      });

      const keys = Object.keys(total);

      playerData.forEach((data) => {
        keys.forEach((key) => {
          if (total?.hasOwnProperty(key) && key !== "name" && key !== "date") {
            total[key] = data[key] ? round(total[key] + data[key], 1) : round(total[key] + 0, 1);
          }
          if(data[key]){
            totalRecordsCount[key] = (totalRecordsCount[key] || 0) + 1;
          }
        });
      });

      const averageKeys = Object.keys(averageValues);

      averageKeys.forEach((key) => {
        if (key in total && key in totalRecordsCount) {
          total[key] = round(total[key] / totalRecordsCount[key], 2);
        }
      });


      return total;
    } else {
      return null;
    }
  };

  const totalColumn = getTotal(columnAccessors, playerData);

  if (totalColumn) {
    playerData.push(totalColumn);
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data: playerData && playerData.length > 0
        ? playerData
        : getEmptyStatTableValuesAccessors(30, columnAccessors).items,
      autoResetPage: true,
      autoResetSortBy: false,
      manualSortBy: true,
      disableMultiSort: true,
      disableSortRemove: true,
      initialState: {
        sortBy: [{ id: order?.id, desc: order?.desc }]
      }
    },
    useSortBy,
  );

  const { desc: descending, id } = sortBy[0] || {};

  useEffect(() => {
    if (id != order?.id || order?.desc != descending) {
      setOrder({ id, desc: descending });
    }
  }, [descending, id]);

  return (
    <>
      <Table
        baseClass={baseClass}
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        rows={rows}
        headerGroups={headerGroups}
        state={sortBy}
        prepareRow={prepareRow} />
      {
        rows.length < 1
          ? (
            <>
              <div className="mls-c-stats__no-results">
                <NoResults size="large" />
                {
                  emptyResultsComponent ? emptyResultsComponent : null
                }
              </div>
            </>
          )
          : null
      }
    </>
  );
};

export default PlayersCareerTable;
